import { useRouteMatch } from "react-router";

export function useToken(): string {
  const {
    params: { token },
  } = useRouteMatch();
  return token;
}
